import {share, tap} from "rxjs/operators";
import {Injectable} from "@angular/core";
import {Observable, Subject} from "rxjs";
import {ProductSummaryItem} from "@backbase/data-ang/arrangements";

@Injectable({
  providedIn: 'root',
})
export class BnAccountDetailService {
  // Observable string account
  private selectedAccount: Subject<ProductSummaryItem> = new Subject<ProductSummaryItem>();

  // Observable string streams
  public selectedAccount$: Observable<ProductSummaryItem> = this.selectedAccount.asObservable().pipe(share());

  public setSelectedAccount(selectedAccount: ProductSummaryItem): void {
    this.selectedAccount.next(selectedAccount);
  }

  static accountlt: ProductSummaryItem | undefined = undefined;
}
